import React from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const schema = z.object({
  name: z.string().trim().min(1, "Name is required").max(255),
});

export type SpecialtyFormValues = z.infer<typeof schema>;

interface SpecialtyFormProps {
  initialData: SpecialtyFormValues;
  loading?: boolean;
  submitLabel: string;
  onSubmit: (values: SpecialtyFormValues) => void;
}

const SpecialtyForm: React.FC<SpecialtyFormProps> = ({
  initialData,
  loading = false,
  submitLabel,
  onSubmit,
}) => {
  const form = useForm<SpecialtyFormValues>({
    resolver: zodResolver(schema),
    defaultValues: initialData,
  });

  return (
    <Form {...form}>
      <form className="space-y-4" onSubmit={form.handleSubmit(onSubmit)}>
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Name</FormLabel>
              <FormControl>
                <Input {...field} placeholder="e.g. Electrical" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <div className="flex justify-end">
          <Button disabled={loading} type="submit">
            {loading ? "Saving..." : submitLabel}
          </Button>
        </div>
      </form>
    </Form>
  );
};

export default SpecialtyForm;
